import { SvgIcon } from "assets/icons";
import { DIMENSION_UNIT, WEIGHT_UNIT } from "config/constants";
import { t } from "i18next";

export const SELLING_STATUS = {
  AVAILABLE: "AVAILABLE",
  CONTACT: "CONTACT",
  UNAVAILABLE: "UNAVAILABLE",
};

export const sellingStatusLabel = {
  [SELLING_STATUS.AVAILABLE]: "Đang kinh doanh",
  [SELLING_STATUS.CONTACT]: "Liên hệ",
  [SELLING_STATUS.UNAVAILABLE]: "Ngừng kinh doanh",
};

export const PRODUCT_TYPE = {
  MATERIAL: "MATERIAL",
  SERVICE: "SERVICE",
  KEY_LICENSE: "KEY_LICENSE",
  ACCOUNT: "ACCOUNT",
};

export const UNIT_DATE = {
  DAY: "DAY",
  MONTH: "MONTH",
  YEAR: "YEAR",
  FOREVER: "FOREVER",
};

export const convertUnit = (unit) => {
  switch (unit) {
    case UNIT_DATE.DAY:
      return t("v2.keyManagement.day");
    case UNIT_DATE.MONTH:
      return t("v2.keyManagement.month");
    case UNIT_DATE.YEAR:
      return t("v2.keyManagement.year");
    case UNIT_DATE.FOREVER:
      return t("v2.keyManagement.forever");
    default:
      return "--";
  }
};

export const keyOnlineTypeLabel = {
  [PRODUCT_TYPE.KEY_LICENSE]: "Key license",
  [PRODUCT_TYPE.ACCOUNT]: "Account",
};

export const dimensionUnitLabel = {
  [DIMENSION_UNIT.CENTIMETER]: "cm",
  [DIMENSION_UNIT.METER]: "m",
  [DIMENSION_UNIT.MILLIMETER]: "mm",
};

export const weightLabel = {
  [WEIGHT_UNIT.GRAM]: "g",
  [WEIGHT_UNIT.KILOGRAM]: "kg",
  [WEIGHT_UNIT.QUINTAL]: "tạ",
  [WEIGHT_UNIT.TON]: "tấn",
};

export const VAT_TYPE = {
  REQUIRED: "REQUIRED",
  NOT_REQUIRED: "NOT_REQUIRED",
  OPTIONAL: "OPTIONAL",
};

export const CheckVatType = (value) => {
  return value === VAT_TYPE.REQUIRED ? (
    <SvgIcon.SuccessIcon />
  ) : value === VAT_TYPE.NOT_REQUIRED ? (
    <SvgIcon.CloseIcon />
  ) : (
    t("v2.product.drawer_edit_product.optional")
  );
};

export const TAXABLE = {
  ALL: "ALL",
  TAXABLE: "TAXABLE",
  NOT_TAXABLE: "NOT_TAXABLE",
};

export const SELLING_STATUS_OPTIONS = [
  {
    value: SELLING_STATUS.AVAILABLE,
    label: "Đang kinh doanh",
  },
  {
    value: SELLING_STATUS.CONTACT,
    label: "Liên hệ",
  },
  {
    value: SELLING_STATUS.UNAVAILABLE,
    label: "Ngừng kinh doanh",
  },
];

export const SEARCH_TYPE = {
  BULK: "BULK",
  SINGLE: "SINGLE",
};

export const PRODUCT_FULFILLMENT_MODE = {
  IN_STOCK: "IN_STOCK",
  PRE_ORDER: "PRE_ORDER",
};

export const DEPOSIT_PAYMENT_METHOD_TYPE = {
  DEPOSIT_BY_MONEY: "DEPOSIT_BY_MONEY",
  DEPOSIT_BY_PERCENT_VALUE: "DEPOSIT_BY_PERCENT_VALUE",
};

export const convertDepositPaymentMethod = (method) => {
  switch (method) {
    case DEPOSIT_PAYMENT_METHOD_TYPE.DEPOSIT_BY_PERCENT_VALUE:
      return "%";
    case DEPOSIT_PAYMENT_METHOD_TYPE.DEPOSIT_BY_MONEY:
      return "";
    default:
      return "%";
  }
};

// R17: thứ tự và màu tag kênh bán, đánh khoá theo id kênh (platform 1 / platform 2).
// Dùng chung cho màn danh sách SP, trang chi tiết, edit mode và modal xác nhận.
export const SALE_CHANNEL_DISPLAY = {
  1: { order: 1, color: "blue" }, // WEB VẬN HÀNH
  3: { order: 1, color: "blue" },
  9: { order: 2, color: "geekblue" }, // WEB ĐẠI LÝ
  10: { order: 2, color: "geekblue" },
  2: { order: 3, color: "green" }, // APP ĐẠI LÝ
  4: { order: 3, color: "green" },
  11: { order: 4, color: "orange" }, // WEB BÁN LẺ
  12: { order: 4, color: "orange" },
};

// Dự phòng khi id kênh trên môi trường khác bảng R17: nhận diện theo tên kênh (không phân biệt hoa thường),
// rồi theo type. Type WEB không phân biệt được WEB VẬN HÀNH / WEB ĐẠI LÝ nên lấy theo WEB VẬN HÀNH.
export const SALE_CHANNEL_DISPLAY_BY_NAME = {
  "WEB VẬN HÀNH": { order: 1, color: "blue" },
  "WEB ĐẠI LÝ": { order: 2, color: "geekblue" },
  "APP ĐẠI LÝ": { order: 3, color: "green" },
  "WEB BÁN LẺ": { order: 4, color: "orange" },
};

export const SALE_CHANNEL_DISPLAY_BY_TYPE = {
  WEB: { order: 1, color: "blue" },
  APP: { order: 3, color: "green" },
  RETAIL: { order: 4, color: "orange" },
};

export const SALE_CHANNEL_DEFAULT_COLOR = "default";

export const SALE_CHANNEL_EMPTY_TEXT = "Chưa có kênh bán";

const normalizeSaleChannelName = (name) =>
  typeof name === "string" ? name.normalize("NFC").trim().replace(/\s+/g, " ").toUpperCase() : "";

// Tra thứ tự và màu của một kênh: ưu tiên id (R17), rồi tên, rồi type. Không khớp gì thì trả null.
// Nhận cả object kênh ({ id, name, type }) lẫn id trần.
export const getSaleChannelDisplay = (channel) => {
  if (channel === null || channel === undefined) return null;
  const isObject = typeof channel === "object";
  const id = isObject ? channel.id : channel;
  if (id !== null && id !== undefined && SALE_CHANNEL_DISPLAY[id]) return SALE_CHANNEL_DISPLAY[id];
  if (!isObject) return null;
  return (
    SALE_CHANNEL_DISPLAY_BY_NAME[normalizeSaleChannelName(channel.name)] ??
    SALE_CHANNEL_DISPLAY_BY_TYPE[typeof channel.type === "string" ? channel.type.toUpperCase() : ""] ??
    null
  );
};

export const getSaleChannelColor = (channel) => getSaleChannelDisplay(channel)?.color ?? SALE_CHANNEL_DEFAULT_COLOR;

// Sắp theo R17. Kênh không nhận diện được xếp cuối, giữ nguyên thứ tự gốc.
export const sortSaleChannels = (channels) => {
  if (!Array.isArray(channels)) return [];
  const UNKNOWN_ORDER = Number.MAX_SAFE_INTEGER;
  return channels
    .filter(Boolean)
    .map((channel, index) => ({ channel, index, order: getSaleChannelDisplay(channel)?.order ?? UNKNOWN_ORDER }))
    .sort((a, b) => a.order - b.order || a.index - b.index)
    .map(({ channel }) => channel);
};
